export default __webpack_public_path__ + "8a10d39c0284818709b74b4aee8991f7.svg";